export const moTradeReleaseCommentFieldId = 'Trade_Release_Comment';
